

export const updateFormFields = (values, dispatch) => {
	dispatch({
		type: "HANDLE MULTIPLE INPUTS",
		payload: {
				usuario: values.usuario,
				nomeLoja: values.nomeLoja,
				nomeLojaFormatado: values.nomeLojaFormatado,
				url: values.urlLoja,
				cor: values.corTemplate,
				logotipo: values.logoLoja,
				email: values.emailLoja,
				template: values.template,
				textoPedidoEntregue: values.textoPedidoEntregue,
				textoPedidoACaminho: values.textoPedidoACaminho,
				apoiador: values.apoiador,
		},
	});
};

export const updateFormField = (field, value, dispatch) => {
	dispatch({
		type: "HANDLE INPUT",
		field: field,
		payload: value,
	});
};